import { Stack, Typography, useTheme } from "@mui/material";

interface ActivityEmptyStateProps {
  /** Imported PNG from `assets/images/nodata`. */
  image: string;
  /** Doubles as the illustration's alt text. */
  title: string;
  description: string;
  /** Illustrations differ in aspect ratio, so each card sets its own width. */
  imageWidth?: string;
}

/**
 * Shared empty state for the Activity & performance cards: illustration, title,
 * then a one-line reason. Fills the card body so the empty card keeps the same
 * height as a card with a chart in it.
 */
export const ActivityEmptyState = ({
  image,
  title,
  description,
  imageWidth = "120px",
}: ActivityEmptyStateProps) => {
  const theme = useTheme();

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      // `flex: 1` fills the card body; the floor keeps the block readable in
      // the cards whose body is not itself a flex container.
      sx={{ flex: 1, minHeight: "160px", gap: "16px", px: "16px" }}
    >
      <img
        src={image}
        alt={title}
        style={{ width: imageWidth, height: "auto" }}
      />
      <Stack alignItems="center" gap="4px">
        <Typography
          variant="caption-2"
          sx={{ color: theme.palette.lightBg.high, textAlign: "center" }}
        >
          {title}
        </Typography>
        <Typography
          variant="body-xsmall"
          sx={{ color: theme.palette.lightBg.low, textAlign: "center" }}
        >
          {description}
        </Typography>
      </Stack>
    </Stack>
  );
};
